export const config = {
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
}